import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ISurvey } from "../../../@types/Surveys";
import { BlackPlus } from "../../../assets/icons/BlackPlus";
import { Pencil } from "../../../assets/icons/Pencil";
import { CustomIconButton } from "../../../components/CustomIconButton";
import { useSurveys } from "../../../hooks/queries/surveys";
import { useModal } from "../../../hooks/useModal";
import { PageLayout } from "../../../layout/components/PageLayout";
import { PageTitle } from "../../../layout/components/PageTitle";
import { truncateText } from "../../../utils/stringFormatter";
import { PageTitleContainer } from "../../PatientWorkflows/PatientWorkflows.styles";
import { AssignToHospitalModal } from "./Components/AssignToHospitalModal";
import { SurveyListTable } from "./Components/SurveyListTable/SurveyListTable";
import {
  SurveysListTableContainer,
  AddSurveyButton,
  SurveyListActions,
} from "./SurveyListPage.styles";

export function SurveysPage() {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(true);
  const [tableData, setTableData] = useState<any>();
  const { openModal, closeModal } = useModal();
  const navigate = useNavigate();
  const { surveys, isRefetching, isFetching, refetch } = useSurveys();
  const handleAddSurveyClick = () => {
    navigate("/surveybuilder");
  };

  const handleAnswerClick = () => {
    navigate("/surveys/answer");
  };

  const handleEditClick = (surveyId: string) => {
    navigate(`/surveybuilder/${surveyId}`);
  };

  const handleAssignQuestioToHospitalClick = (survey: ISurvey) => {
    openModal(
      <AssignToHospitalModal
        refetch={refetch}
        onClose={closeModal}
        survey={survey}
      />,
      {
        width: "60vw",
        maxHeight: "95vh",
        showCloseButton: true,
      }
    );
  };

  const parseDataToSurveyTable = (data: any) => {
    const formatttedDataTable: any[] = [];
    data.map((survey: ISurvey, index: number) =>
      formatttedDataTable.push({
        name: <span title={survey.name}>{truncateText(survey.name)}</span>,
        type: survey.type ?? "",
        createdBy: survey.createdBy,
        assignToHospital: (
          <div>
            <CustomIconButton
              key={index}
              onClick={() => {
                handleAssignQuestioToHospitalClick(survey);
              }}
            >
              <BlackPlus />
            </CustomIconButton>
          </div>
        ),
        edit: (
          <CustomIconButton
            key={index}
            onClick={() => {
              handleEditClick(survey.id ?? "");
            }}
          >
            <Pencil />
          </CustomIconButton>
        ),
      })
    );
    return formatttedDataTable;
  };

  useEffect(() => {
    if (!isFetching && !isRefetching && surveys) {
      const formattedData = parseDataToSurveyTable(surveys);
      setTableData(formattedData);
      setLoading(false);
    }
  }, [surveys]);

  return (
    <PageLayout>
      <PageTitleContainer>
        <PageTitle>{t("surveys_title")}</PageTitle>
      </PageTitleContainer>
      <SurveysListTableContainer>
        <SurveyListActions>
          <AddSurveyButton onClick={handleAnswerClick}>
            {t("surveys_list_answer")}
          </AddSurveyButton>
          <AddSurveyButton onClick={handleAddSurveyClick}>
            {t("surveys_list_addSurvey")}
          </AddSurveyButton>
        </SurveyListActions>
        <SurveyListTable isLoading={loading} content={tableData} />
      </SurveysListTableContainer>
    </PageLayout>
  );
}
